import { initPhotoSwipe } from './photoswipe';
import { initSwiper } from './swiper';
import { initFlatpickr } from './flatpickr';
import { initScrollHint } from './scroll-hint';
let initialized = false;

export function initVendors(): void {
    if (initialized) return;
    initialized = true;
    initPhotoSwipe();
    initSwiper();
    initFlatpickr();
    initScrollHint();
}
